module.exports = __webpack_public_path__ + "img/logo-main.47b850cb.svg";